<template>
  <v-card outlined class="mx-3">
    <v-data-table
      :headers="headers"
      :items="data"
      :items-per-page="1000"
      class="product-group-sold-table"
      v-if="data.length"
      hide-default-footer
    >
      <template v-slot:item.totalPrice="{ item }">
        {{ formatPrice(+item.totalPrice / 1000000) }}
      </template>
      <template v-slot:item.totalPriceSuccess="{ item }">
        {{ formatPrice(+item.totalPriceSuccess / 1000000) }}
      </template>
    </v-data-table>
    <common-no-result
      v-if="!data.length"
    />
  </v-card>
</template>

<script>
import { formatPrice } from '@/helpers/utils'

export default {
  props: {
    data: {
      type: Array,
      default: () => ([])
    },
  },
  data() {
    return {
      headers: [
        { text: 'NHÓM SẢN PHẨM', align: 'center', value: 'product.group.name' },
        { text: 'TÊN SẢN PHẨM', align: 'center', value: 'product.name' },
        { text: 'SỐ LƯỢNG BÁN (KHOÁ)', align: 'center', value: 'countItems' },
        { text: 'DOANH THU (TRIỆU)', align: 'center', value: 'totalPrice' },
        { text: 'DOANH THU THÀNH CÔNG (TRIỆU)', align: 'center', value: 'totalPriceSuccess' },
      ],
    }
  },
  methods: {
  },
}
</script>

<style lang="scss">
  .product-group-sold-table {
    tr th {
      background-color: #9e9e9e;
    }
    tr th:not(:last-child), tr td:not(:last-child) {
      border-right: thin solid rgba(0, 0, 0, 0.12)
    }
  }
</style>